import * as actionType from "./productActionType";

const initialState = {
  isLoading: false,
  products: [],
  wishlist: [],
  product: {},
  home: {},
  isAdded: false
};

export const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.FETCH_PRODUCTS:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                products: action.payload ? action.payload.data : [],
            };
        case actionType.FETCH_WISHLIST:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_WISHLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_WISHLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                wishlist: action.payload ? action.payload.data : [],
            };
        case actionType.ADD_TO_WISHLIST:
            return {
                ...state,
                isLoading: true,
                isAdded: false
            };
        case actionType.ADD_TO_WISHLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.ADD_TO_WISHLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isAdded: true,
            };
        case actionType.REMOVE_TO_WISHLIST:
            return {
                ...state,
                isLoading: true,
                isAdded: false
            };
        case actionType.REMOVE_TO_WISHLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.REMOVE_TO_WISHLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isAdded: true,
            };
        case actionType.FETCH_HOME_PRODUCTS:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_HOME_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_HOME_PRODUCTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                home: action.payload ? action.payload.data : {},
            };
        case actionType.FETCH_PRODUCT:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_PRODUCT_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_PRODUCT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                product: action.payload ? action.payload.data : {},
            };
        default:
            return state;
    }
}